import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { CSVLink } from 'react-csv';
import csv from 'csvtojson';
import { apiUrl, googleMapApiKey } from '../config/config';
import './AdminControl.css';

class AdminControl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customers: [],
    };
  }

  componentDidMount() {
    fetch(`${apiUrl}/customer`)
      .then(results => results.json())
      .then((data) => {
        this.setState({ customers: data });
      });
  }

  render() {
    const { token } = this.props;
    const csvHeaders = [
      { label: '序號', key: 'key' },
      { label: '客戶名稱', key: 'name' },
      { label: 'email', key: 'email' },
      { label: '連絡電話', key: 'phone' },
      { label: '郵遞區號', key: 'zipcode' },
      { label: '縣市', key: 'county' },
      { label: '鄉鎮區', key: 'district' },
      { label: '地址', key: 'address' },
      { label: '輸入日期', key: 'date' },
    ];
    const csvData = this.state.customers.map(elem => ({
      key: elem.key,
      name: elem.name,
      phone: elem.phone,
      email: elem.email,
      zipcode: elem.zipcode,
      county: elem.county,
      district: elem.district,
      address: elem.address,
      date: elem.date,
    }));
    let restoreData;

    const showNotification = (paramObj) => {
      const { content, extraClass } = paramObj;
      const element = document.getElementById('notification');
      element.className = 'notification';
      element.classList.add(extraClass);
      element.childNodes[1].innerHTML = content;
      setTimeout(() => {
        element.classList.add('is-hidden');
      }, 3000);
    };

    const restoreCustomer = () => {
      if (!restoreData) {
        showNotification({
          content: 'No restore data',
          extraClass: 'is-danger',
        });
        return;
      }

      const saveCustomer = (obj) => {
        fetch(`${apiUrl}/customer`, {
          method: 'POST',
          body: JSON.stringify(obj),
          headers: {
            'Content-Type': 'application/json',
          },
        })
          .then(() => {
            showNotification({
              content: 'Restore successful',
              extraClass: 'is-success',
            });
          })
          .catch((err) => {
            throw err;
          });
      };

      Promise.all(this.state.customers.map(elem =>
        fetch(`${apiUrl}/customer/${elem.id}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }))).then(() => {
        csv()
          .fromString(restoreData)
          .on('json', (jsonObj) => {
            saveCustomer({
              key: jsonObj['序號'],
              name: jsonObj['客戶名稱'],
              phone: jsonObj['連絡電話'],
              email: jsonObj.email,
              zipcode: jsonObj['郵遞區號'],
              county: jsonObj['縣市'],
              district: jsonObj['鄉鎮區'],
              address: jsonObj['地址'],
              date: jsonObj['輸入日期'],
            });
          })
          .on('done', (error) => {});
      });
    };

    const updateGeocode = () => {
      fetch(`${apiUrl}/location?_limit=999`)
        .then(results => results.json())
        .then((data) => {
          const promiseArr = data.map((location) => {
            const url = `https://maps.google.com/maps/api/geocode/json?address=${
              location.address
            }&key=${googleMapApiKey}`;
            return fetch(url)
              .then(results => results.json())
              .then((mapData) => {
                if (mapData.results[0] && mapData.results[0].geometry) {
                  fetch(`${apiUrl}/location/${location._id}`, {
                    method: 'PUT',
                    body: JSON.stringify({
                      map_lat: mapData.results[0].geometry.location.lat,
                      map_lng: mapData.results[0].geometry.location.lng,
                    }),
                    headers: {
                      'Content-Type': 'application/json',
                    },
                  })
                    .then(() => {})
                    .catch((err) => {
                      throw err;
                    });
                }
              });
          });
          Promise.all(promiseArr).then((values) => {
            showNotification({
              content: 'Update successful',
              extraClass: 'is-success',
            });
          });
        });
    };
    return (
      <div className="admin-control">
        <div className="level">
          <div className="level-item">
            <button className="button" onClick={this.state.logout}>
              Logout
            </button>
          </div>
        </div>
        <div className="level">
          <div className="level-left">
            <div className="level-item">
              <CSVLink
                className="button"
                filename="customer_data.csv"
                target=""
                data={csvData}
                headers={csvHeaders}
              >
                Export customer csv data
              </CSVLink>
            </div>
            <div className="level-item">
              <div className="field has-addons">
                <div className="control">
                  <div className="file has-name is-right">
                    <label className="file-label">
                      <input
                        className="file-input"
                        type="file"
                        accept=".csv"
                        name="resume"
                        id="file"
                        onChange={(elem) => {
                          if (elem.target.files.length > 0) {
                            const file = elem.target.files[0];
                            const reader = new FileReader();
                            reader.onload = () => {
                              restoreData = reader.result;
                              console.log('reader.result', reader.result);
                            };
                            reader.readAsText(file);
                          }
                        }}
                      />
                      <span className="file-cta">
                        <span className="file-icon">
                          <i className="fas fa-upload" />
                        </span>
                        <span className="file-label">Choose a file...</span>
                      </span>
                    </label>
                  </div>
                </div>
                <div className="control">
                  <button className="button" onClick={restoreCustomer}>
                    Restore customer data
                  </button>
                </div>
              </div>
            </div>
            {process.env.NODE_ENV !== 'production' && (
              <div className="level-item">
                <button className="button" onClick={updateGeocode}>
                  Update location geocode
                </button>
              </div>
            )}
          </div>
        </div>
        <div className="notification is-hidden" id="notification">
          <button
            className="delete"
            onClick={(event) => {
              event.target.parentNode.classList.add('is-hidden');
            }}
          />
          <p className="notification-content" />
        </div>
      </div>
    );
  }
}

AdminControl.propTypes = {
  token: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  products: state.products,
  categories: state.categories,
  locations: state.locations,
  news: state.news,
});

export default connect(mapStateToProps)(AdminControl);



// WEBPACK FOOTER //
// ./src/containers/AdminControl.js